import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { tblrows,getmessage } from './Dynamictable';
import {clrwidgate,stvlsn,loadwidgate,gtpblvl,gtvlacht,runtimerjob,setdefaulvillachat,entervilla,villachanged,usermoved,showhidediv} from './userdefaultdata';
import Usersession from './Usersession';

export default class Viewpublivillas extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
        name: "World",
       respdata: null,   
       url: "",
       tblheaders:[''],		
       tblrows: [{id:1, nm: 'c'}],	
       
       tblfiterdata: [{uid:0,villaid:"",villaname:"",vt:2,ucnt:0}]
 	
    };

   
  setvillamembers(vtp:any,vid:any,preid:any){
 
    if(vtp == "1"){
      let villas = Usersession.getPubvillas();
      for(let i =0;i< villas.length;i++){
              
                 let rv = villas[i];
	         if(rv['villaid'] == vid){
		   const cnt = rv['ucnt'] + 1;
	           rv['ucnt'] = cnt;
                   if(preid){
                      
			if(rv['villaid'] == preid){
			  const cntmns = rv['ucnt'] - 1;
			  rv['ucnt'] = cntmns;

			}
		    }
                    	
		 } 
	      villas[i] = rv;
		 
	  } 
	Usersession.setPubvillas(villas);

     }
  } 
   
    
   closevilla(e:any,id:any,vnm:any,ucn:any){
       if(ucn < 20){
       const removevillaid = 	Usersession.getVillaId();
        setdefaulvillachat();
        Usersession.setVillasts(1);
	clrwidgate('wigtarea');
 
        stvlsn(id,vnm);
        Usersession.setVillatype("1");

	loadwidgate('vilnm',3);
	loadwidgate('cbmaindiv',4);
        const previd = Usersession.getVillaId();
        Usersession.setVillaname(vnm);
	Usersession.setVillaId(id);
	Usersession.setVillatype("1");
        villachanged();

       this.setvillamembers("1",id,previd);   
   
      //  gtvlacht(id,"1");
 
       const vlid = id; 
        

        const vsts =  Usersession.getVillasts();
        if(vsts != 0) {
	loadwidgate('wigtarea',1);
       getmessage('Please try again....','')
        }
        else{

          usermoved(id,removevillaid);

       }

	}
        else{
	getmessage('No Vacant','Please visit other villa')
	}
         e.preventDefault();

   }

    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        //debugger;
        // runtimerjob(true);
	const villas = Usersession.getPubvillas();
        
        this.setserverurl();
        const ar = [{id:1, nm: 'c'},{id:2, nm: 'd'}]
	//alert(JSON.stringify(villas));
	const cols = ["Villa Name"];
        this.setState({ tblheaders: cols });
	this.setState({ tblrows: ar});
        
	this.setState({ tblfiterdata: villas});
	
      

    }
 
 

   

    
 render() {

   
     return (

         <form>
	<div className="per100" id="postmain">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		
		<thead>
		   <tr>	
			{this.state.tblheaders.map((str,index)=>(
			<th className="comptd">{str}</th>
			))}
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdata.map((row,index)=>(
			<tr>
				<td className="comptd">
                           <a href="#" className="blanka"  onClick={e=>this.closevilla(e,row.villaid,row.villaname,row.ucnt)} title="Villa" > 
                                    <div>
                                    {row.villaname} ({row.ucnt})
                                    </div>
				  </a>
                                 </td>
				
			</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

